import OLMapProperty from 'ol/MapProperty';

export const MapProperty = Object.assign({
  // workbooks and classic, no need to change:
  ROUTING_CONTEXT: 'ROUTING_CONTEXT',
  TIMELINE_PLAYER_CURRENT_POINTS_OVERLAYS: 'timelinePlayerCurrentPointsOverlays',
  LAST_SELECTION_CLICK_PX: 'lastSelectionClickPx',
  HIDPI: 'hidpi',
  PIXEL_RATIO: 'pixelRatio', // is also set in the OL Map constructor, but it is private and there is no getter, so we also add it as a map property
  PRIMARY_INTERACTION: 'primaryInteraction',
  CONTEXT_PUSH_ENABLED: 'contextPushEnabled', // we will need the flag for workbooks to do the new push only for workbook map views

  // workbooks
  WORKBOOK_VIEW_ID: 'workbookViewId',
  WORKBOOK_POSTMESSAGE_API: 'workbookPostMessageApi', // should be migrated to view api
  IS_WORKBOOK_MAP: 'isWorkbookMap', // should actually be a util
  IS_CLIENT_SIDE_RENDERING: 'isClientSideRendering',
  /**
   * For client-side export of external image layers, we need to set the crossOrigin property of the image elements
   * used to load the images to 'anonymous' in order to be able to access the pixel content of
   * the canvases where the images are drawn. Otherwise, the canvases are considered 'tainted'
   * and reading operations get blocked.
   *
   * For more details see: https://developer.mozilla.org/en-US/docs/Web/HTML/CORS_enabled_image
   *
   * This is done through OpenLayer by setting the crossOrigin attribute of the sources. The property will be set to 'anonymous' if this flag is set to true on the map.
   * Currently supported are WMS and WMTS.
   */
  IS_CROSS_ORIGIN: 'isCrossOrigin', // used for export maps (cloned workbook map) where we need to set the cross-origin attribute of the image elements

  // should be migrated to workbook redux store
  /** In live mode, some operations like zooming etc. are still permitted. This flag
   * allows to distinguish between those that are triggered by live mode timer and
   * those that are triggered by the user.
   */
  IS_LIVE_MODE_REQUEST: 'IS_LIVE_MODE_REQUEST',
  PROJECTION_WKT: 'projectionWkt', // ! UNCLEAR if this won't cause GIS dependencies in workbook module on backend
  DEFAULT_COORDINATE_VISUALIZATION_SRS: 'defaultCoordinateVisualizationSrs', // is already in cadenza store
  DEFAULT_STYLES: 'defaultStyles', // is already in cadenza store
  DRAW_STYLES: 'drawStyles', // is already in cadenza store
  HIGHLIGHT_STYLES: 'highlightStyles', // is already in cadenza store
  DEFAULT_STYLES_SERIALIZED: 'defaultStylesSerialized', // is already in cadenza store
  DRAW_STYLES_SERIALIZED: 'drawStylesSerialized', // is already in cadenza store
  HIGHLIGHT_STYLES_SERIALIZED: 'highlightStylesSerialized', // is already in cadenza store

  // classic, needs to be removed in workbooks:
  ID: 'id',
  CONTEXT_URL: 'contextUrl', // will not be needed in workbooks when we change to map context building from workbook redux store
  OVERVIEW_MAP_DYNAMIC_EXTENT: 'overviewMapDynamicExtent', // as soon as we have coupled workbook overview map views
  OVERVIEW_MAP_DYNAMIC_ASPECT_RATIO: 'overviewMapDynamicAspectRatio', // as soon as we have coupled workbook overview map views

  // classic, is not used in workbooks:
  GAZETTEER_SUGGESTION_PROVIDERS: 'gazetteerSuggestionProvider',
  LAYER_ACTIONS_PROVIDER: 'layerActionsProvider',
  POLYGON_CONDITION_LAYER: 'polygonConditionLayer',
  EDITING_LAYER: 'editingLayer',
  SKETCH_LAYER: 'sketchLayer',
  SKETCH_EDITOR: 'sketchEditor',
  SKETCH_ENABLED: 'sketch',
  TOOLBAR_VISIBLE: 'toolbarVisible',
  CONTROLS_VISIBLE: 'controlsVisible',
  LEGEND_VISIBLE: 'legendVisible',
  SETTINGS_VISIBLE: 'settingsVisible',
  TAGS: 'tags',
  CONTEXT_MENU_ENABLED: 'contextMenuEnabled',
  SELECTED_LAYER: 'selectedLayer'

  // should be added for workbooks:
  // WORKBOOK_ID_AND_HASH // optionally set, to distinguish between workbook map views and global standard map
}, OLMapProperty);
